import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import * as Yup from 'yup';
import * as nl from './locales/nl/yup-validation.inline';
import * as en from './locales/en/yup-validation.inline';

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    fallbackLng: 'en',
    defaultNS: 'common'
  });

// setup Yup translations
i18n.on('languageChanged', (lng) => {
  // Note: Doesn't work instantly when changing language in the app, need to do hard refresh
  Yup.setLocale(lng === 'nl' ? nl : en);
});

export default i18n;
